<div class="container">
  <div class="label-container">
    @let selectImage = config().catchPhrase.selectImage;
    <img
      [alt]="selectImage.alternativeText | replaceVars: maxReward()"
      [src]="
        selectImage.imageUrlByType?.[challenge().type] ?? selectImage.imageUrl
      "
    />

    <div
      class="catchphrase-container"
      [style.fontStyle]="config().catchPhrase.amountFontStyle"
      [style.color]="config().catchPhrase.amountColor"
      [style.fontFamily]="config().catchPhrase.amountFontFamily"
    >
      @let collectUpTo = config().catchPhrase.collectUpTo;
      @if (collectUpTo) {
        <p
          class="label"
          [style.fontSize]="collectUpTo.fontSize"
          [style.lineHeight]="collectUpTo.lineHeight"
          [style.fontFamily]="collectUpTo.fontFamily"
          [innerHTML]="collectUpTo.label | safe"
        ></p>
      }

      @let splitCurrencyAmount = config().splitCurrencyAmount;
      @if (splitCurrencyAmount) {
        @let amountParts = maxReward() | formatAmountParts;
        <p
          [style.fontFamily]="config().catchPhrase.amountFontFamily"
          class="amount split-amount"
        >
          <span class="amount-currency">{{ amountParts.currency }}</span>
          <span class="amount-integer">{{ amountParts.integer }}</span>
          <span class="amount-fraction">{{ amountParts.fraction }}</span>
        </p>
      } @else {
        <p
          [style.fontFamily]="config().catchPhrase.amountFontFamily"
          class="amount"
        >
          {{ maxReward() | formatReward }}
        </p>
      }

      @let points = config().catchPhrase.points;
      @if (points) {
        <p class="points" [style.fontFamily]="points.pointsFontFamily">
          {{ points.pointsLabel }}
        </p>
      }
    </div>
  </div>

  <div class="button-container">
    <b2c-button
      [styles]="{
        fontSize: '11px',
        color: config().buttonCatchPhrase.buttonColor,
        width: selectionInProgress() ? '100px' : '160px',
        fontFamily: config().buttonCatchPhrase.buttonFontFamily,
        borderRadius: config().buttonCatchPhrase.buttonBorderRadius,
        borderColor: config().buttonCatchPhrase.buttonBackgroundColor,
        backgroundColor: config().buttonCatchPhrase.buttonBackgroundColor,
      }"
      data-cy="select_btn"
      [loading]="selectionInProgress()"
      [title]="config().buttonCatchPhrase.buttonLabel"
      [attr.aria-label]="config().buttonCatchPhrase.buttonLabel"
      (click)="
        selectChallenge(
          challenge(),
          phase(),
          isBisCampaign(),
          isEventChallenge()
        )
      "
      [disabled]="
        challenge().isOutOfStock() ||
        selectionInProgress() ||
        blockSelectionButton()
      "
    >
      {{ config().buttonCatchPhrase.buttonLabel }}
    </b2c-button>
  </div>
</div>
